import { useEffect, useState } from "react";
import { PageButton } from "./components";
import style from "./Pagination.module.scss";
import { ArrowSvg } from "./Arrow.svg";

export function Pagination({
  count,
  activePage,
  onClickPage,
}: {
  count: number;
  activePage: number;
  onClickPage: (page: number) => void;
}) {
  const [pagesButton, setPagesButton] = useState<JSX.Element[]>([]);
  console.log(count)
  useEffect(() => {
    const element: JSX.Element[] = [];

    if (count <= 7) {
      for (let i = 0; i < count; i++) {
        element.push(
          <PageButton
            key={i}
            numberPage={i}
            activePage={activePage}
            onClick={onClickPage}
            className={
              activePage === count - 1 && i === count - 2
                ? "!flex"
                : activePage === 0 && i === 1
                  ? "!flex"
                  : ""
            }
          />,
        );
      }
    } else {
      if ([0, 1, 2, 3].includes(activePage)) {
        for (let i = 0; i < 5; i++) {
          element.push(
            <PageButton
              key={i}
              numberPage={i}
              activePage={activePage}
              onClick={onClickPage}
              className={activePage === 0 && i === 1 ? "!flex" : ""}
            />,
          );
        }
        element.push(
          <div key="treeDotsBack" className={style["treeDotsForward"]}>
            ...
          </div>,
        );
        element.push(
          <PageButton
            key={count - 1}
            numberPage={count - 1}
            activePage={activePage}
            onClick={onClickPage}
          />,
        );
      } else if (
        [count - 1, count - 2, count - 3, count - 4].includes(activePage)
      ) {
        element.push(
          <PageButton
            key={0}
            numberPage={0}
            activePage={activePage}
            onClick={onClickPage}
          />,
        );
        element.push(
          <div key="treeDotsForward" className={style["treeDotsForward"]}>
            ...
          </div>,
        );
        for (let i = count - 5; i < count; i++) {
          element.push(
            <PageButton
              key={i}
              numberPage={i}
              activePage={activePage}
              onClick={onClickPage}
              className={
                activePage === count - 1 && i === count - 2 ? "!flex" : ""
              }
            />,
          );
        }
      } else {
        element.push(
          <PageButton
            key={0}
            numberPage={0}
            activePage={activePage}
            onClick={onClickPage}
          />,
        );
        element.push(
          <div key={"treeDotsBack"} className={style["treeDotsForward"]}>
            ...
          </div>,
        );
        element.push(
          <PageButton
            key={activePage - 1}
            numberPage={activePage - 1}
            activePage={activePage}
            onClick={onClickPage}
          />,
        );
        element.push(
          <PageButton
            key={activePage}
            numberPage={activePage}
            activePage={activePage}
            onClick={onClickPage}
          />,
        );
        element.push(
          <PageButton
            key={activePage + 1}
            numberPage={activePage + 1}
            activePage={activePage}
            onClick={onClickPage}
          />,
        );
        element.push(
          <div key={"treeDotsForward"} className={style["treeDotsForward"]}>
            ...
          </div>,
        );
        element.push(
          <PageButton
            key={count - 1}
            numberPage={count - 1}
            activePage={activePage}
            onClick={onClickPage}
          />,
        );
      }
    }

    setPagesButton(element);
  }, [count, activePage]);

  return (
    <div className={style["paginationPagesButton"]}>
      <button
        className={style["oneStepButton"]}
        disabled={activePage === 0}
        onClick={() => onClickPage(activePage - 1)}
      >
        <ArrowSvg />
      </button>
      <div className="flex gap-[15px]">{pagesButton}</div>
      <button
        className={style["oneStepButton"]}
        disabled={(activePage + 1) === count}
        onClick={() => onClickPage(activePage + 1)}
      >
        <ArrowSvg className="rotate-180" />
      </button>
    </div>
  );
}
